// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__ro5PK","signatureButtonsRight":"ModalSign_signatureButtonsRight__2rne_"};